/**
 * Shared grading policy types for GradingPilot.
 * These mirror the TypeScript definitions used for Conestoga policies.
 */
export const ProgramTypes = [
  "Certificate",
  "Diploma",
  "Advanced Diploma",
  "Degree",
  "Graduate Certificate",
  "Apprenticeship",
  "Other"
];

/**
 * @typedef {"Certificate"|"Diploma"|"Advanced Diploma"|"Degree"|"Graduate Certificate"|"Apprenticeship"|"Other"} ProgramType
 *
 * @typedef {Object} GradeScaleRow
 * @property {string} alphaGrade
 * @property {number} gradePoint
 * @property {number} lowPercent
 * @property {number} highPercent
 * @property {string} description
 *
 * @typedef {Object} GradingPolicy
 * @property {string} id
 * @property {string} name
 * @property {string} description
 * @property {string} sourceUrl
 * @property {boolean} isHistoric
 * @property {string} [effectiveFrom]
 * @property {ProgramType[]} associatedProgramTypes
 * @property {GradeScaleRow[]} gradeScale
 */

export const EmptyGradeScaleRow = {
  alphaGrade: "",
  gradePoint: 0,
  lowPercent: 0,
  highPercent: 0,
  description: ""
};

export const buildProgramLabel = (programType) => {
  switch (programType) {
    case "Advanced Diploma":
      return "Advanced Diploma";
    case "Graduate Certificate":
      return "Graduate Certificate";
    case "Apprenticeship":
      return "Apprenticeship";
    case "Certificate":
    case "Diploma":
    case "Degree":
      return `${programType} Programs`;
    default:
      return "Other";
  }
};
